import type { MutationFunction, MutationFunctionOptions, FetchResult } from '@apollo/client';
import {
    ToggleFolderTreeCollapsedMutation,
    ToggleFolderTreeCollapsedDocument,
    ToggleFolderTreeCollapsedMutationVariables,
} from '../graphql/__generated__/ToggleFolderTreeCollapsedStateMutation.interface';
import { updateUserConfiguration } from 'owa-session-store';
import { getApolloClient } from 'owa-apollo';
import { DEFAULT_USER_CONFIG } from 'owa-graph-schema';

/**
 * Toggle the Collapsed of folder tree and update both local and server user config
 */
export function toggleFolderTreeCollapsed(
    toggleFolderTreeCollapsedMutationFunction: MutationFunction<
        ToggleFolderTreeCollapsedMutation,
        ToggleFolderTreeCollapsedMutationVariables
    > | null,
    isCollapsed: boolean
) {
    const newIsCollapsedState = !isCollapsed;

    const mutationOptions: MutationFunctionOptions<
        ToggleFolderTreeCollapsedMutation,
        ToggleFolderTreeCollapsedMutationVariables
    > = {
        variables: {
            input: {
                id: DEFAULT_USER_CONFIG,
                updates: {
                    UserOptions: { IsMailRootFolderTreeCollapsed: newIsCollapsedState },
                },
            },
        },
        optimisticResponse: {
            __typename: 'Mutation',
            updateUserConfiguration: {
                id: DEFAULT_USER_CONFIG,
                __typename: 'UserConfiguration',
                UserOptions: {
                    IsMailRootFolderTreeCollapsed: newIsCollapsedState,
                    __typename: 'UserOptions',
                },
            },
        },
    };

    /**
     * Satchel update
     */
    updateUserConfiguration(config => {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (55,9): Object is possibly 'undefined'.
        // @ts-expect-error
        config.UserOptions.IsMailRootFolderTreeCollapsed = newIsCollapsedState;
    });

    /**
     * Execution
     */
    let toggleFolderTreeCollapsedMutationFunction_0 = toggleFolderTreeCollapsedMutationFunction;
    if (!toggleFolderTreeCollapsedMutationFunction_0) {
        const client = getApolloClient();
        toggleFolderTreeCollapsedMutationFunction_0 = (
            options?: MutationFunctionOptions<
                ToggleFolderTreeCollapsedMutation,
                ToggleFolderTreeCollapsedMutationVariables
            >
        ): Promise<FetchResult> => {
            return client.mutate({
                variables: options?.variables,
                optimisticResponse: options?.optimisticResponse,
                mutation: ToggleFolderTreeCollapsedDocument,
            });
        };
    }

    toggleFolderTreeCollapsedMutationFunction_0(mutationOptions);
}
